import JsCookies from 'js-cookie';

import AbstractView from 'abstracts/AbstractView';

import Lazyloader from 'loaders/Lazyloader';



export default new class InfoMessage extends AbstractView {
	
	constructor() {
		super();
		
		this.isActive = false;
	}
	
	
	init( $wrapper = null ) {
		this.initDOM( $wrapper );
		
		if ( this.$wrapper.length == 0 )
			return;
		else
			this.isActive = true;
		
		this.initEl();
		this.initTl();
		this.bindEvents();
		
		this.resize();
	}
	
	
	initDOM() {
		super.initDOM();
		
		this.$wrapper = $( '#infos_message' );
		this.$inner   = this.$wrapper.find( '.infos_message_inner' );
		this.$close   = this.$inner.find( '.infos_message--close' );
	}
	
	
	initEl() {
		super.initEl();
		
		this.id        = 'infos_message-accepted__' + this.$wrapper[ 0 ].getAttribute( 'data-id' );
		this.hasCookie = JsCookies.get( this.id ) === 'true';
	}
	
	
	bindEvents() {
		super.bindEvents();
		
		this.eh.clickBtn = this._hide.bind( this );
		this.$close.on( 'click', this.eh.clickBtn );
	}
	
	
	show( needTrans = false ) {
		if ( !this.isActive )
			return;
		
		if ( !this.hasCookie )
			this.$wrapper[ 0 ].style.display = 'block';
		
		if ( needTrans )
			this.tl.show = gsap.timeline()
				.from( this.$wrapper, { duration: 0.3, yPercent: 100 }, 0 )
				.from( this.$inner, { duration: 0.3, yPercent: -100 }, 0 );
	}
	
	
	_hide() {
		JsCookies.set( this.id, 'true', { expires: 30 } );
		
		this.tl.hide = gsap.timeline( {
			onComplete: this._onHideComplete.bind( this )
		} )
			.to( this.$wrapper, { duration: 0.3, yPercent: 100 }, 0 )
			.to( this.$inner, { duration: 0.3, yPercent: -100 }, 0 );
	}
	
	
	_onHideComplete() {
		this.$wrapper[ 0 ].style.display = 'none';
	}
	
};
